function Logo({ otherClasses }) {
  return (<h3 className={`logo-text ${otherClasses}`}>Coursable</h3>);
}

export default Logo;